export const spacing = {
  none: '0px',
  xs:   '2px',
  sm:   '4px',
  md:   '8px',
  lg:   '12px',
  xl:   '14px',
  xxl:  '16px',
  xxxl: '22px',
  huge: '28px',
  giant: '34px',
} as const;
